import script from "./AdsCabinetPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdsCabinetPage.vue?vue&type=script&setup=true&lang=ts"

import "./AdsCabinetPage.vue?vue&type=style&index=0&id=305915cc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-305915cc"]])

export default __exports__